import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListCreatedAtCell } from './charge-point-list-created-at.cell';
import { ChargePointListCreatedAtHeader } from './charge-point-list-created-at.header';

export const ChargePointListCreatedAtColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['createdAt']
> = {
  enableSorting: true,
  header: ChargePointListCreatedAtHeader,
  cell: ChargePointListCreatedAtCell,
};
